// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/*** 获取管理员列表 */
export async function getAdminList(
  page?: number,
  page_size?: number,
  end_time?: number,
  start_time?: number,
  status?: number,
  content?: string,
  role?:string,
  options?: { [key: string]: any }
) {
  return request<API.AdminList.Response>("/api/v1/admins", {
    method: "GET",
    params: {
      page,
      page_size,
      end_time,
      start_time,
      status,
      content,
      role
    },
    ...(options || {}),
  });
}

 /*** 创建管理员 */
 export async function createNewAdmin(
  body: API.CreateAdmin.Request,
  options?: { [key: string]: any }
) {
  return request<API.CreateAdmin.Response>("/api/v1/admins", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/**编辑管理员 */
export async function editAdmin(
  id: number,
  body: API.EditAdmin.Request,
  options?: { [key: string]: any }
) {
  return request<API.EditAdmin.Response>(`/api/v1/admins/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
